import { useState } from 'react';

import { Box, Heading, Paragraph } from '@rover/kibble/core';

import Modal from './Modal';
import OverflowTextWrapper from './OverflowTextWrapper';

type Props = {
  text: string;
  title?: string;
  fixedSizedContent?: React.ReactNode;
  numberOfLines?: number;
  onReadMore?: () => void;
} & Partial<React.ComponentProps<typeof Paragraph>>;

const OverflowTextModal = ({
  fixedSizedContent,
  text,
  title,
  numberOfLines = 4,
  onReadMore,
  ...props
}: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (): void => {
    setIsOpen((prev) => !prev);
    if (onReadMore) onReadMore();
  };

  return (
    <>
      <Box flexDirection="column">
        {title && <Heading size="300">{title}</Heading>}
        {fixedSizedContent && fixedSizedContent}
        <OverflowTextWrapper
          text={text}
          numberOfLines={numberOfLines}
          onReadMore={handleClick}
          {...props}
        />
      </Box>
      <Modal isOpen={isOpen} onClose={handleClick}>
        {title && (
          <Box width="100%">
            <Heading size="300">{title}</Heading>
          </Box>
        )}
        {fixedSizedContent && <Box width="100%">{fixedSizedContent}</Box>}
        <Paragraph
          sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}
          webProps={{ maxWidth: 'none' }}
        >
          {text}
        </Paragraph>
      </Modal>
    </>
  );
};

export default OverflowTextModal;
